import { LEVEL_IDS } from '../config.js';
import { Timer } from '../game/Timer.js';

const LEVEL_NAMES = { 1: '入门', 2: '进阶', 3: '大师' };

export class LevelSelect {
  /**
   * @param {HTMLElement} root
   * @param {import('../storage/ProgressStore.js').ProgressStore} store
   * @param {object} callbacks
   * @param {(levelId: number) => void} callbacks.onPick
   * @param {() => void} callbacks.onBack
   */
  constructor(root, store, { onPick, onBack }) {
    this.root = root;
    this.store = store;
    this.onPick = onPick;
    this.onBack = onBack;
    this.el = null;
  }

  show() {
    this.hide();
    const panel = document.createElement('div');
    panel.className = 'panel level-select';
    panel.innerHTML = `
      <h2>选择关卡</h2>
      <div class="level-grid"></div>
      <div class="btn-row">
        <button class="btn secondary" data-action="back">返回</button>
      </div>
    `;
    const grid = panel.querySelector('.level-grid');
    for (const id of LEVEL_IDS) {
      const unlocked = this.store.isUnlocked(id);
      const best = this.store.getBestTime(id);
      const card = document.createElement('div');
      card.className = 'level-card' + (unlocked ? '' : ' locked');
      card.innerHTML = `
        <div class="lv-num">${id}</div>
        <div class="lv-name">${LEVEL_NAMES[id] || ''}</div>
        <div class="lv-time">${unlocked ? (best !== null ? Timer.format(best) : '未通关') : '🔒 未解锁'}</div>
      `;
      if (unlocked) {
        card.addEventListener('click', () => this.onPick(id));
      }
      grid.appendChild(card);
    }
    panel.querySelector('[data-action="back"]').addEventListener('click', () => this.onBack());
    this.root.appendChild(panel);
    this.el = panel;
  }

  hide() {
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
    this.el = null;
  }
}
